import { Link } from "@tanstack/react-router";
import { Transaction_Type } from "schema/gen/es/chiikipoint/model/v2/model_pb";
import ChevronRight from "~icons/material-symbols/chevron-right";
import { css } from "../../../../styled-system/css";
import { IconImage } from "../../../components/icon-image";
import { formatDate } from "../../../libs/date";
import { t } from "../../../libs/i18n";
import { formatNumber } from "../../../libs/utils";

export type Tx = {
  id: string;
  amount: number;
  name: string;
  createdAt: Date;
  iconUrl: string;
  type: Transaction_Type;
};

type MonthlyTransactionBlockProps = {
  month: string;
  txs: Tx[];
};

export function MonthlyTransactionBlock({
  month,
  txs,
}: MonthlyTransactionBlockProps) {
  return (
    <div>
      <div
        className={css({
          fontSize: "18px",
          marginBottom: "12px",
          pl: "16px",
          color: "text.secondary",
        })}
      >
        {month}
      </div>
      <div
        className={css({
          bg: "white",
          overflow: "hidden",
        })}
      >
        {txs.map((tx, index) => (
          <Link
            key={tx.id}
            className={css({
              display: "flex",
              alignItems: "center",
              padding: "12px 16px",
              borderBottom: index < txs.length - 1 ? "1px solid #eee" : "none",
              gap: "8px",
            })}
            to={"/transactions/$groupId"}
            params={{
              groupId: tx.id,
            }}
          >
            <div
              className={css({
                borderRadius: "full",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexShrink: 0,
                bg: "surface.secondary",
              })}
            >
              <IconImage src={tx.iconUrl} alt={tx.name} size={42} />
            </div>
            <div
              className={css({
                flex: 1,
                minWidth: 0,
                pl: "8px",
              })}
            >
              <div
                className={css({
                  color: "text.primary",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                })}
              >
                {tx.name}
              </div>
              <div className={css({ fontSize: "12px", color: "#666" })}>
                {formatDate(tx.createdAt, "dateTimeColon")}
              </div>
            </div>
            <div
              className={css({
                color: tx.amount > 0 ? "text.accentSuccess" : "text.secondary",
                flexShrink: 0,
                fontWeight: tx.amount > 0 ? "600" : "400",
              })}
            >
              {tx.type === Transaction_Type.REFUND
                ? t("返金済み")
                : `${formatNumber(tx.amount)}pt`}
            </div>
            <ChevronRight
              className={css({
                color: "#999",
                flexShrink: 0,
              })}
            />
          </Link>
        ))}
      </div>
    </div>
  );
}
